const strategyActionTypes = {


    GET_STRATEGY_SUCCESS: 'GET_STRATEGY_SUCCESS',
    GET_STRATEGY_FAILURE: 'GET_STRATEGY_FAILURE',

    START_UPDATE_STRATEGY: 'START_UPDATE_STRATEGY',
    UPDATE_STRATEGY_SUCCESS: 'UPDATE_STRATEGY_SUCCESS',
    UPDATE_STRATEGY_FAILURE: 'UPDATE_STRATEGY_FAILURE',

    START_ADD_STRATEGY: 'START_ADD_STRATEGY',
    ADD_STRATEGY_SUCCESS: 'ADD_STRATEGY_SUCCESS',
    ADD_STRATEGY_FAILURE: 'ADD_STRATEGY_FAILURE',
        
    START_DELETE_STRATEGY: 'START_DELETE_STRATEGY',
    DELETE_STRATEGY_SUCCESS: 'DELETE_STRATEGY_SUCCESS',
    DELETE_STRATEGY_FAILURE: 'DELETE_STRATEGY_FAILURE',
    
    START_GET_CHARGE_POINT_STRATEGY: 'START_GET_CHARGE_POINT_STRATEGY',
    GET_CHARGE_POINT_STRATEGY_SUCCESS: 'GET_CHARGE_POINT_STRATEGY_SUCCESS',
    GET_CHARGE_POINT_STRATEGY_FAILURE: 'GET_CHARGE_POINT_STRATEGY_FAILURE',

    SELECT_STRATEGY: 'SELECT_STRATEGY',
    RESET_STATE_INFO: 'RESET_STATE_INFO',
};

export default strategyActionTypes;